import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import DashboardCard from "src/components/home/DashboardCard";
import LargeAdBanner from "src/components/banner/LargeAdBanner";

import { RootState } from "src/store/store";

import PostContainer from "src/container/post";
import RankingContainer from "src/container/ranking";
import SecuritiescompanyContainer from "src/container/securitiescompany";
import StockContainer from "src/container/stock";
import BlogContainer from "src/container/blog";
// import HotContainer from "src/container/hot";

const HomeContainer: React.FC = () => {
  const summaries = useSelector((state: RootState) => state.main.summaries);
  const serviceType = useSelector((state: RootState) => state.session.serviceType);

  const stats = useMemo(() => [
    { label: "오늘의 텔레모아", icon: 0 },
    { label: "오늘 누적 게시글", value: summaries?.message_cnt },
    { label: "오늘 누적 조회수", value: summaries?.view_cnt },
    { label: "누적 구독자수", value: summaries?.subscribe_cnt}
  ], [summaries]);

  const topBannerLink = () => {
    window.open("https://www.thebrink.co.kr", "_blank");
  };

  const bottomBannerLink = () => {
    window.open("https://t.me/primestocknote", "_blank");
  };

  return (
    <div className="container mt-4">
      <DashboardCard stats={stats}/>
      <LargeAdBanner position="top" onClick={topBannerLink} />
      
      <div className="row">
        <PostContainer rowPerPage={10} />
      </div>


      <LargeAdBanner position="bottom" onClick={bottomBannerLink} />

      <div className="row">
      <div className={`px-3 py-4 col-12 col-lg-${serviceType === "ST"?"6":"12"}`}>
        <RankingContainer rowPerPage={10} />
      </div>
      <div className={`px-3 py-4 col-12 col-lg-6`}>
        {serviceType === "ST" && <SecuritiescompanyContainer rowPerPage={10} />}
      </div>
      </div>
      <div className="row">
        {serviceType === "ST" && <StockContainer rowPerPage={10} />}
        {serviceType === "ST" && <BlogContainer rowPerPage={10} />}
      </div>
      {/* {serviceType === "ST" && <HotContainer preview={true} />} */}
    </div>
  );
};

export default HomeContainer;
